// AI-CONTEXT: See docs/features/update-aanvragen.md

import { useMemo } from 'react'
import { useFirestoreNoCompagnyWithStatus } from '../../../firebase/useFirestore'
import sortUpdateRequests from '../../../helpers/updateRequests/sortUpdateRequests'
import updateRequestListState from '../../../helpers/updateRequests/updateRequestListState'
import UpdateRequestList from '../../updates/UpdateRequestList'

/**
 * De updateverzoeken die één klantorganisatie heeft ingediend.
 *
 * Anders dan de tabbladen Taken en Notities hiernaast leest dit blok de
 * KLANT-omgeving, niet de beheeromgeving: het verzoek hoort bij de organisatie
 * die het instuurde. Daarom `useFirestoreNoCompagnyWithStatus` — de gewone
 * hooks scopen op de ingelogde omgeving.
 *
 * Drie toestanden, en 'leeg' is er maar één van. De regels weigeren een read op
 * een omgeving waar dit account geen lid van is, en die weigering levert een
 * lege lijst op in plaats van een fout. Zonder onderscheid staat er 'geen
 * verzoeken' bij een organisatie die er wel degelijk heeft.
 * AI-CONTEXT: See docs/inbox.md Bug #133
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 *
 * @param {object} props
 * @param {string} props.projectId - CompagnyID van de klantorganisatie
 */
const ProjectUpdateRequests = ({ projectId }) => {

  // Firestore — '' is het signaal voor 'nog geen waarde'; de engine slaat de
  // zoekopdracht dan over in plaats van hem leeg uit te voeren.
  const { docs, error, loading } = useFirestoreNoCompagnyWithStatus(
    'UpdateRequests',
    'CompagnyID',
    projectId || '',
  )

  const lijst = useMemo(() => sortUpdateRequests(docs), [docs])

  const toestand = updateRequestListState({ docs, error, loading })

  // JSX
  if (toestand === 'denied') {
    // Bewust geen oorzaak noemen: dit kan lidmaatschap zijn, maar net zo goed
    // een regel die nog niet in de Firebase Console staat. Een verkeerde
    // verklaring stuurt de lezer het bos in.
    return (
      <p className="updates-empty">
        Geen toegang tot de updateverzoeken van deze organisatie.
      </p>
    )
  }

  if (toestand === 'failed') {
    return (
      <p className="updates-empty">
        We konden de updateverzoeken niet ophalen. Probeer het later opnieuw.
      </p>
    )
  }

  if (toestand === 'loading') return <p className="updates-empty">Laden…</p>

  if (toestand === 'empty') {
    return <p className="updates-empty">Deze organisatie heeft nog geen updateverzoeken ingediend.</p>
  }

  return <UpdateRequestList requests={lijst} />
}

export default ProjectUpdateRequests
